import { Button } from '../Input2';
import { General } from '../StrokeIcons';
import Popup, { PopupProps } from './Popup';

type CadenceDeletePopupProps = PopupProps & {
  onClose: () => void;
  onDelete: () => void;
  name?: string;
  pendingResponse?: string;
};

export default function DeleteCadencePopup({ onClose, onDelete, name, pendingResponse }: CadenceDeletePopupProps) {
  return (
    <Popup onClose={onClose} className="max-w-lg">
      <h2 className="text-xl font-bold">Are you sure?</h2>

      {name != null && (
        <>
          {pendingResponse && name && (
            <p>
              This action will dismiss the response received from <b>{name}</b>: <br /> {pendingResponse}.
            </p>
          )}
          <p>This can not be undone.</p>
        </>
      )}
      {name == null && (
        <p>
          This action will dismiss all the <b>contact replies</b> and <b>document views</b>. This action can not be
          undone.
        </p>
      )}

      <Button icon={<General.Trash01 />} color="red" onClick={onDelete}>
        Yes, Delete it
      </Button>
    </Popup>
  );
}
